var _g, _text, _text2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIncomplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.223 33.75",
    style: {
      enableBackground: "new 0 0 26.223 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.997,17.375c0.606-0.613,0.961-1.726,1.177-2.931c0.35-0.009,0.813-0.773,1.066-1.796   c0.268-1.085,0.197-2.038-0.161-2.127c-0.035-0.009-0.07-0.003-0.106,0.005c0.081-0.877,0.056-1.707-0.193-2.067   c-0.776-1.11-0.842-2.089-2.018-2.512C14.588,5.523,16,4,16,4s-5.024,0.141-6.095,1.945C9.276,7,8.972,7.348,8.197,8.458   c-0.25,0.361-0.257,1.193-0.15,2.069c-0.045-0.012-0.088-0.017-0.13-0.006c-0.359,0.089-0.431,1.042-0.163,2.127   c0.254,1.023,0.717,1.787,1.066,1.796c0.216,1.205,0.57,2.317,1.177,2.931c1.5,1.518-1.5,3.036-1.5,3.036s-0.937,0.395-1.042,0.438   c-0.66,0.285-1.552,0.683-2.416,1.105C2.568,19.755,1,16.561,1,13C1,6.383,6.383,1,13,1c6.617,0,12,5.383,12,12   c0,2.473-0.77,4.759-2.059,6.668l0.576,0.95C25.072,18.476,26,15.849,26,13c0-7.18-5.82-13-13-13C5.82,0,0,5.82,0,13   c0,6.922,5.415,12.565,12.238,12.961l3.945-6.499C15.622,18.893,15.248,18.134,15.997,17.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,15.927L12.777,27h13.445L19.5,15.927z M20,26h-1v-1h1V26z M19,24v-5h1v5H19z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 42,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Hea Poh Lin")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 47,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIncomplete);
export default __webpack_public_path__ + "static/media/profile-incomplete.7d4e8706.svg";
export { ForwardRef as ReactComponent };